import { ColumnEditorOptions } from "primereact/column";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { QuestionOption } from "../../../types/checklist";

interface MultiChoiceEditorProps {
    options: ColumnEditorOptions;
    questionOptions: QuestionOption[];
}

export const MultiChoiceEditor = ({ options, questionOptions }: MultiChoiceEditorProps) => {
    const handleChange = (e: MultiSelectChangeEvent) => {
        if (options.editorCallback) {
            options.editorCallback(e.value);
        }
    };

    const multiSelectOptions = questionOptions.map((opt) => ({
        label: opt.text,
        value: opt.id,
    }));

    // Parse value - could be array or JSON string
    let currentValue = options.value;
    if (typeof currentValue === "string") {
        try {
            currentValue = JSON.parse(currentValue);
        } catch {
            currentValue = [];
        }
    }
    if (!Array.isArray(currentValue)) {
        currentValue = [];
    }

    return (
        <MultiSelect
            value={currentValue}
            options={multiSelectOptions}
            onChange={handleChange}
            placeholder="Select options"
            className="w-full"
            display="chip"
            autoFocus
        />
    );
};

export const multiChoiceDisplayTemplate = (value: unknown, questionOptions?: QuestionOption[]): string => {
    if (!value) return "";

    // Parse value if it's a string
    let values = value;
    if (typeof values === "string") {
        try {
            values = JSON.parse(values);
        } catch {
            return String(value);
        }
    }

    if (!Array.isArray(values)) return String(value);
    if (!questionOptions) return values.join(", ");

    return values
        .map((v) => {
            const option = questionOptions.find((opt) => opt.id === v);
            return option?.text ?? v;
        })
        .join(", ");
};
